// Web-only strings for the emoji feature (keys prefixed `web.emoji.`), BOTH languages. What the Apple
// screens already say comes from their keys: channel.addReaction («Reaccionar»), channel.emojiRecents
// («Recientes»), channel.reaction.details («Reacciones»), channel.reaction.you / .unknown.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.emoji.search': 'Buscar emoji',
    'web.emoji.insert': 'Emoji',
    'web.emoji.results': 'Resultados',
    'web.emoji.noResults': 'Ningún emoji coincide con «%@»',
    'web.emoji.hint': 'Flechas para moverte · Intro para elegir · Esc para cerrar',
    'web.emoji.category.smileys-emotion': 'Caritas y emociones',
    'web.emoji.category.people-body': 'Personas',
    'web.emoji.category.animals-nature': 'Animales y naturaleza',
    'web.emoji.category.food-drink': 'Comida y bebida',
    'web.emoji.category.travel-places': 'Viajes y lugares',
    'web.emoji.category.activities': 'Actividades',
    'web.emoji.category.objects': 'Objetos',
    'web.emoji.category.symbols': 'Símbolos',
    'web.emoji.category.flags': 'Banderas',
    'web.emoji.category.custom': 'Personalizados',
    'web.emoji.reactions.all': 'Todas',
    'web.emoji.reactions.viewAll': 'Ver reacciones',
  },
  en: {
    'web.emoji.search': 'Search emoji',
    'web.emoji.insert': 'Emoji',
    'web.emoji.results': 'Results',
    'web.emoji.noResults': 'No emoji match “%@”',
    'web.emoji.hint': 'Arrows to move · Return to pick · Esc to close',
    'web.emoji.category.smileys-emotion': 'Smileys & emotion',
    'web.emoji.category.people-body': 'People',
    'web.emoji.category.animals-nature': 'Animals & nature',
    'web.emoji.category.food-drink': 'Food & drink',
    'web.emoji.category.travel-places': 'Travel & places',
    'web.emoji.category.activities': 'Activities',
    'web.emoji.category.objects': 'Objects',
    'web.emoji.category.symbols': 'Symbols',
    'web.emoji.category.flags': 'Flags',
    'web.emoji.category.custom': 'Custom',
    'web.emoji.reactions.all': 'All',
    'web.emoji.reactions.viewAll': 'View reactions',
  },
};
